
/**
 * 
 * 
 */

import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProgressBar from "./../Progress/ProgressBar";
import BotQuestionnaire from "./BotQuestionnaire";


function QuestionnaireContainer( props ) {

  const navigate = useNavigate();
  let { id } = useParams();
  
  const handleProceedClick = () => {
    if( window.appLastGuidaneResesponse2.hasRecievedGR ){
      navigate( './../results/' + window.appLastGuidaneResesponse2.guidanceResponseId );
    } else {
      console.log('No results yet');
    }
  }

  const handleNotRefugeeFinish = () => {
    navigate( './../../finished/ref' );
  }

  let resourceUrl = 'QuestionnaireResponse/' + id;

  return (
    <div>
      
      <div className="app-page questionnaire">
        <div className="questionnaire-inner">
          <BotQuestionnaire questionnaireResponseId={id} handleShowResults={handleProceedClick} handleNotRefugeeFinish={handleNotRefugeeFinish} resourceUrl={resourceUrl} />
        </div>
      </div>
      {/*
      <div className="app-page landing" onClick={handleProceedClick}>
        <span className="btn">Tulemused</span>
      </div>
      */}
    </div>
  );
}


class Questionnaire extends React.Component {

  constructor( props ) {
    super( props );

    //console.log( "input props for questionnaire ", props );
    //console.log( "input this.props.match ", this.props.match );
    
  }

  componentDidMount() {
  }

  render() {

    return (
      <div className="app-page questionnaire">
        <div className="questionnaire-inner">
          
          <ProgressBar completed="34" className="mb-3" />

          <div className="app-fragment question">
            <div className="question-avatar mb-3"></div>
            <div className="question-text">
              Kas te kardate olukordi, nagu üksinda reisimine, avalikes kohtades viibimine, mida võib olla raske vältida ja kus rahutustunde või paanikahoo korral ei pruugi abi kättesaadav olla?
            </div>
          </div>

          <div className="app-fragment">
            <a href="#" className="btn-inline-answer">Vähemalt neli järjestikust päeva, aga vähem kui nädal</a>
            <a href="#" className="btn-inline-answer">Jah</a>
            <a href="#" className="btn-inline-answer">Vahel harva</a>
            <a href="#" className="btn-inline-answer">ei</a>
            <a href="#" className="btn-inline-answer">Vähemalt neli järjestikust päeva, aga vähem kui nädal</a>
            <a href="#" className="btn-inline-answer">Jah</a>
            <a href="#" className="btn-inline-answer">Ei</a>
            <a href="#" className="btn-inline-answer">Jätan vastamata</a>
            <a href="#" className="btn-inline-answer selected">Ei soovi vastata</a>
            <a href="#" className="btn-inline-answer">Olen kindel</a>
            <a href="#" className="btn-inline-answer">Veel üks pakkumine</a>
            <a href="#" className="btn-inline-answer">Viimane</a>
          </div>
        </div>
      </div>
    );
  }

}

export default QuestionnaireContainer; 